module.exports = __webpack_public_path__ + "img/gift2.055054eb.png";